
export const MODIFY_THEME = 'modify_theme';

export function modifyThemeAction(theme){
  return {
    type: MODIFY_THEME,
    name: theme
  }
}
